import styled from "styled-components";

const colors = {
  bg: "#111", // fundal închis
  text: "#fff", // text alb
  accent: "#8b8064", // auriu
  line: "rgba(255,255,255,0.2)",
};

export const FooterWrap = styled.footer`
  background: ${colors.bg};
  color: ${colors.text};
  padding: 40px 20px 20px;
`;

export const FooterInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  text-align: center;
`;

export const TopRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
  }
`;

export const LogoBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  img {
    height: 40px;
    width: auto;
  }
`;

export const BrandText = styled.span`
  font-size: 20px;
  font-family: "Dancing Script", cursive;
  font-weight: 600;
  color: ${colors.text};
`;

export const Socials = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 0.95rem;

  span {
    margin-right: 6px;
    font-weight: 500;
    color: ${colors.text};
  }
`;

export const SocialLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: ${colors.line};
  color: ${colors.accent};
  transition: background 0.2s ease, color 0.2s ease;

  &:hover {
    background: ${colors.accent};
    color: #000;
  }

  i {
    font-size: 14px;
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: ${colors.line};
`;

export const LinksRow = styled.div`
  font-size: 0.9rem;
  color: ${colors.text};

  a {
    color: ${colors.text};
    text-decoration: none;
    margin: 0 4px;
    transition: color 0.2s ease;

    &:hover {
      color: ${colors.accent};
    }
  }
`;

export const Credit = styled.div`
  font-size: 0.85rem;
  color: #ccc;

  span {
    color: ${colors.accent};
    font-weight: 600;
  }
`;
